<style src="./ItemDocuments.scss" lang="scss"></style>
<template>
  <section class="form-box item-documents">
    <section class="commands">
      <button
        @click="downloadRms"
        type="button"
        class="cp1-small-button download">
        Baixar
      </button>

    </section>
    <ul class="header">
      <li class="checker"></li>
      <li class="id">Item</li>
      <li class="description">Descrição</li>
      <li class="labs">Marcas</li>
      <li class="doc"><span class="angle45">RMS</span></li>
    </ul>

    <ul class="list">
      <item-row-document
        v-for="(item, itemIdx) in preparedItems"
        :key="itemIdx"
        :info="item"
        :event-date="eventDate"
        @selection="(v) => selection(item, v)" />
    </ul>
  </section>
</template>

<script>
import ItemRowDocument from '../item-row-document/ItemRowDocument'

export default {
  name: 'ItemDocuments',
  components: {
    ItemRowDocument
  },
  props: {
    items: {
      default: null
    },
    eventDate: {
      default: null
    }
  },
  data: () => ({
    preparedItems: []
  }),
  watch: {
    items: {
      handler (v) {
        this.prepareItems(v)
      },
      immediate: true
    }
  },
  methods: {
    prepareItems (items) {
      const preparedItems = items.map(i => {
        return {
          id: i._id,
          isChecked: false,
          lot: i.itemInfo.lot,
          number: i.itemInfo.number,
          description: i.itemInfo.description,
          wasQuoted: i.itemQuoted && i.itemQuoted.cost,
          rmsAnvisa: i.rmsAnvisa,
          rmsAnvisaCode: i.itemQuoted && i.itemQuoted.rmsCode,
          rmsLab: i.rmsAnvisa && i.rmsAnvisa.lab,
          quotedLab: i.itemQuoted.lab
        }
      })
      this.preparedItems = preparedItems
    },
    async downloadRms () {
      const filteredList = this.preparedItems.filter(i => i.isChecked)

      try {
        const response = await this.$store.dispatch('Rms/MERGE_RMS_FROM_LIST', { list: filteredList })
        const newBlob = new Blob([response], {type: 'application/pdf'})

        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = 'REGISTROS.pdf'
        link.click()
        setTimeout(() => {
          window.URL.revokeObjectURL(data)
        }, 100)
      } catch (error) {
        return Error(error)
      }
    },
    selection (item, v) {
      const markedList = this.preparedItems.map(i => {
        if (i.id.toString() === item.id.toString()) {
          i.isChecked = !i.isChecked
        }

        return i
      })

      this.preparedItems = markedList
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-rms/components/item-documents/ItemDocuments.vue